/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {BarChart, LineChart, PieChart} from '../../../components/Charts';
export const italyGeneralData = {
  population: '59.24 million (2021)',
  laborForce: '24,954,973 (2021)',
  unemploymentRate: '7.8% (September 2022)',
  gdpPerCapita: '26,710 euros (2021)'
};
export const italyProvincePurchasingPower = [{
  name: 'Milan',
  value: 25077
}, {
  name: 'Northern Provinces Avg',
  value: 22000
}, {
  name: 'Italy Average',
  value: 17799
}, {
  name: 'European Average',
  value: 14739
}, {
  name: 'Southern Provinces Avg',
  value: 12000
}];
export const europeClothingSpending2018 = [{
  name: 'United Kingdom',
  value: 65.4
}, {
  name: 'Germany',
  value: 62.7
}, {
  name: 'Italy',
  value: 52.4
}, {
  name: 'France',
  value: 35.7
}, {
  name: 'Spain',
  value: 24.1
}];
export const euClothingSpendingPerCapita = [{
  name: 'Luxembourg',
  value: 1130
}, {
  name: 'Austria',
  value: 810
}, {
  name: 'Netherlands',
  value: 770
}, {
  name: 'Denmark',
  value: 750
}, {
  name: 'Italy',
  value: 710
}, {
  name: 'Germany',
  value: 640
}, {
  name: 'EU Average',
  value: 490
}];
export const fashionTurnoverData = [{
  year: '2019',
  turnover: 90237,
  variation: 0.8
}, {
  year: '2020',
  turnover: 68761,
  variation: -23.8
}, {
  year: '2021',
  turnover: 83338,
  variation: 21.2
}, {
  year: '2022 (Forecast)',
  turnover: 96672,
  variation: 16.0
}];
export const euTextileMarketShare = [{
  name: 'Italy',
  value: 36,
  metric: 'Turnover'
}, {
  name: 'Germany',
  value: 15,
  metric: 'Turnover'
}, {
  name: 'France',
  value: 10,
  metric: 'Turnover'
}, {
  name: 'Spain',
  value: 7,
  metric: 'Turnover'
}, {
  name: 'Other EU Countries',
  value: 32,
  metric: 'Turnover'
}];
export const euEmploymentShare = [{
  name: 'Italy',
  value: 22
}, {
  name: 'Romania',
  value: 11
}, {
  name: 'Poland',
  value: 11
}, {
  name: 'Portugal',
  value: 9
}, {
  name: 'Other EU Countries',
  value: 47
}];
export const euExportShare = [{
  name: 'Italy',
  value: 27
}, {
  name: 'Germany',
  value: 19
}, {
  name: 'Spain',
  value: 11
}, {
  name: 'France',
  value: 11
}, {
  name: 'Other EU Countries',
  value: 32
}];
export const italyTradeData = [{
  year: '2019',
  exports: 71552,
  imports: 39285
}, {
  year: '2020',
  exports: 56168,
  imports: 34677
}, {
  year: '2021',
  exports: 67963,
  imports: 41349
}, {
  year: '2022 (Forecast)',
  exports: 80877,
  imports: 52840
}];
export const euClothingExportsShare = [{
  name: 'Italy',
  value: 33,
  amount: 10
}, {
  name: 'Germany',
  value: 17,
  amount: 5
}, {
  name: 'Spain',
  value: 14,
  amount: 4
}, {
  name: 'France',
  value: 13,
  amount: 4
}, {
  name: 'Other EU Countries',
  value: 23,
  amount: 7
}];
export const topItalianBrands = [{
  name: 'Gucci',
  position: 1,
  category: 'Luxury'
}, {
  name: 'Prada',
  position: 2,
  category: 'Luxury'
}, {
  name: 'Valentino',
  position: 3,
  category: 'Luxury'
}, {
  name: 'Miu Miu',
  position: 4,
  category: 'Luxury'
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    strong: "strong",
    p: "p",
    h3: "h3",
    em: "em"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "General data"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Metric"
          }), _jsx(_components.th, {
            children: "Value"
          }), _jsx(_components.th, {
            children: "Source"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Population:"
            })
          }), _jsx(_components.td, {
            children: "59.24 million (2021)"
          }), _jsx(_components.td, {
            children: "Eurostat, November 2022"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Labor force:"
            })
          }), _jsx(_components.td, {
            children: "24,954,973 (2021)"
          }), _jsx(_components.td, {
            children: "World Bank Open Data"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Unemployment rate:"
            })
          }), _jsx(_components.td, {
            children: "7.8% (September 2022)"
          }), _jsx(_components.td, {
            children: "Tradingeconomics.com based on data from ISTAT"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "GDP per capita (PPP):"
            })
          }), _jsx(_components.td, {
            children: "26,710 euros (2021)"
          }), _jsx(_components.td, {
            children: "Eurostat, November 2022"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Economy"
    }), "\n", _jsx(_components.p, {
      children: "The world's eighth-largest gross domestic product (GDP) belongs to Italy. It is also the eurozone's third-largest economy. Italy contributed 12.4% to the GDP in the European Union in 2020."
    }), "\n", _jsx(_components.p, {
      children: "Source: Investopedia article 'The Top 25 Economies in the World', based on The World Bank data GDP 2020. Last updated in September, 2022. & CBS in an article in July 2021 based on information by Eurostat"
    }), "\n", _jsx(_components.h2, {
      children: "Household income & purchasing power"
    }), "\n", _jsx(_components.p, {
      children: "Household disposable income per inhabitant in Italy, adjusted for price levels, in 2019 amounted to 23,000 euros per inhabitant."
    }), "\n", _jsx(_components.p, {
      children: "Source: CBS in an article in July 2021 based on information by Eurostat (Adjusted gross disposable income of households per capita in PPS)"
    }), "\n", _jsx(_components.p, {
      children: "Italy had an average purchasing power of 17,799 euros per capita for spending and savings in 2019, putting the country around 21 percent above the European average that sits at 14,739 euros."
    }), "\n", _jsx(BarChart, {
      data: italyProvincePurchasingPower,
      title: "Italy Purchasing Power by Region 2019 (euros per capita)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Italy exhibits a striking contrast in purchasing power distribution, with a notable gap between its prosperous north and its less affluent south. First place goes to the province of fashion capital Milan with a purchasing power of 25,077 euros per capita, which is almost 41 percent above the national average and around 70 percent above the European average."
    }), "\n", _jsx(_components.p, {
      children: "Source: GfK Purchasing Power Europe 2019, October 2019."
    }), "\n", _jsx(_components.h2, {
      children: "Clothing consumption: The Italians spend on fashion"
    }), "\n", _jsx(_components.p, {
      children: "Italy was the third largest consumer of clothing in the European Union in 2018."
    }), "\n", _jsx(BarChart, {
      data: europeClothingSpending2018,
      title: "European Clothing Spending 2018 (billions euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      valueSuffix: "B",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Source: Consumer spending on clothing in the European Union 2018, by country, Statista, July 2021"
    }), "\n", _jsx(_components.p, {
      children: "Household expenditure for clothing & footwear in Italy in 2020: 5.4%. For comparison: Europeans spent an average of 4.1% of total household expenditure on clothing and footwear."
    }), "\n", _jsx(_components.p, {
      children: "Source: Household expenditure by category, European Union, 2020 (as % of total expenditure), Eurostat."
    }), "\n", _jsx(_components.p, {
      children: "Italians spend on average 710 euros per year for their clothes. The European average stands at 490 euros. Italians are fifth in the ranking, behind Luxembourg, Austria, Netherlands and Denmark."
    }), "\n", _jsx(BarChart, {
      data: euClothingSpendingPerCapita,
      title: "EU Clothing Spending per Capita 2020 (euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Source: Facts & Key Figures 2022 Euratex report. Source: EU household consumption of clothing in 2020, per capita. Eurostat."
    }), "\n", _jsx(_components.h2, {
      children: "Italy: a vivid fashion industry"
    }), "\n", _jsx(_components.h3, {
      children: "Textile and Fashion is a key economic sector in Italy"
    }), "\n", _jsx(_components.p, {
      children: "Home to some of the world's most famous fashion houses and luxury brands like Bottega Veneta, Gucci, Prada, Versace, Giorgio Armani, Missoni, Moschino, Roberto Cavalli, Valentino and Dolce & Gabbana, Italy holds a distinctive and unique position within the global market of fashion and clothing."
    }), "\n", _jsx(_components.p, {
      children: "Source: Sistema Moda Italia, from The Italian Textile Industry - a Key Economic report, published by ITMA Services, organiser of ITMA 2023, 2022 ITMA Services."
    }), "\n", _jsx(_components.p, {
      children: "According to Claudio Marenzi, President of Confindustria Moda, the Italian fashion, textile, and accessories industry holds a position of utmost significance on the global stage."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "The Italian fashion industry: turnover, businesses & employees"
      })
    }), "\n", _jsx(LineChart, {
      data: fashionTurnoverData,
      title: "Italian Fashion Industry Turnover 2019-2022 (millions euros)",
      dataKey: "turnover",
      xAxisKey: "year",
      valuePrefix: "€",
      valueSuffix: "M"
    }), "\n", _jsx(_components.p, {
      children: "Source: Fashion Economic Trends. Fonte: Camera Nazionale della Moda Italiana, December 2022."
    }), "\n", _jsx(_components.p, {
      children: "The sector comprises around 58,000 businesses and employed 560,000 workers in 2020 (latest number available)."
    }), "\n", _jsx(_components.p, {
      children: "Source: Fashion Economic Trends Fonte: Camera Nazionale della Moda Italiana, December 2022."
    }), "\n", _jsx(_components.h2, {
      children: "Manufacturing / Fashion Production"
    }), "\n", _jsx(_components.p, {
      children: "The highest concentration of fashion manufacturing activities in the EU can be found in Italy."
    }), "\n", _jsx(_components.p, {
      children: "Source: European Union website, Fashion and high-end industries in the EU"
    }), "\n", _jsx(_components.p, {
      children: "\"'Made in Italy' in fashion is synonymous with exclusivity. It's the know-how and expert craftsmanship that position them in the global market,\" said Claudio Marenzi, President of Confindustria Moda."
    }), "\n", _jsx(_components.p, {
      children: "\"Fashion is Italy's second-largest manufacturing sector. With its extensive influence on retail and related services, the sector directly employs nearly 600,000 workers and impacts an equal number of indirect jobs,\" said Carlo Capasa, president of the Italian Fashion Chamber CNMI."
    }), "\n", _jsx(_components.p, {
      children: "Number of wearing apparel manufacturers in Italy in 2019: 29,774."
    }), "\n", _jsx(_components.p, {
      children: "Source: Statista."
    }), "\n", _jsx(_components.p, {
      children: "Turnover of the manufacture of clothing in Italy is 27.2 billion euros in 2020, according to Statista."
    }), "\n", _jsx(_components.p, {
      children: "Italy also produces a lot of shoes: it accounts for about 50% of the shoe production in the EU."
    }), "\n", _jsx(_components.p, {
      children: "Source: European Commission website, based on CIRCABC database data"
    }), "\n", _jsx(_components.h2, {
      children: "Italy holds the top position as the leading contributor to the textile and clothing industry within the European Union"
    }), "\n", _jsx(_components.p, {
      children: "Italy is the largest contributor to the textile and clothing industry in the EU, when it comes to turnover, employment and export."
    }), "\n", _jsx(PieChart, {
      data: euTextileMarketShare,
      title: "EU Textile & Clothing Industry Turnover Share (%)",
      dataKey: "value",
      nameKey: "name",
      valueSuffix: "%"
    }), "\n", _jsx(_components.p, {
      children: "Italy has the largest member state share: it accounts for 36% of the turnover in the EU textile and clothing industry."
    }), "\n", _jsx(PieChart, {
      data: euEmploymentShare,
      title: "EU Textile & Clothing Employment Share (%)",
      dataKey: "value",
      nameKey: "name",
      valueSuffix: "%"
    }), "\n", _jsx(_components.p, {
      children: "Italy has the most employment in the total EU. Italy has a member state share of employment of 22%, followed by Romania with 11% and Poland with 11%."
    }), "\n", _jsx(PieChart, {
      data: euExportShare,
      title: "EU Textile & Clothing Export Share (%)",
      dataKey: "value",
      nameKey: "name",
      valueSuffix: "%"
    }), "\n", _jsx(_components.p, {
      children: "Italy is the largest exporter in the EU. It accounts for 27% of the export, followed by Germany with 19%, Spain by 11% and France by 11%."
    }), "\n", _jsx(_components.h2, {
      children: "Italy: Import & Export"
    }), "\n", _jsx(LineChart, {
      data: italyTradeData,
      title: "Italian Fashion Exports 2019-2022 (millions euros)",
      dataKey: "exports",
      xAxisKey: "year",
      valuePrefix: "€",
      valueSuffix: "M",
      valueLabel: "Exports"
    }), "\n", _jsx(LineChart, {
      data: italyTradeData,
      title: "Italian Fashion Imports 2019-2022 (millions euros)",
      dataKey: "imports",
      xAxisKey: "year",
      valuePrefix: "€",
      valueSuffix: "M",
      valueLabel: "Imports"
    }), "\n", _jsx(_components.p, {
      children: "Source: Fashion Economic Trends. Fonte: Camera Nazionale della Moda Italiana, December 2022."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "As mentioned in the paragraph above, Italy is the largest exporter of clothing in the EU"
      })
    }), "\n", _jsx(BarChart, {
      data: euClothingExportsShare,
      title: "EU Clothing Exports to Non-EU Countries 2020 (billions euros)",
      dataKey: "amount",
      xAxisKey: "name",
      valuePrefix: "€",
      valueSuffix: "B",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Italy exported 10 billion euros worth of clothing to non-EU member states in 2020, 33% of total extra-EU clothing exports by value."
    }), "\n", _jsx(_components.p, {
      children: "Sources: Eurostat news 'Where do our clothes come from?', April 2021 & Statista Chart Where The EU Imports Its Clothes From 2021, April 2021"
    }), "\n", _jsx(_components.h3, {
      children: "Major trading partners"
    }), "\n", _jsx(_components.p, {
      children: "In 2020, major trading partners for Italy in textiles and clothing were Germany, France, Switzerland, United Kingdom and United States for exports and China, Spain, Germany, France and Bangladesh for imports."
    }), "\n", _jsx(_components.p, {
      children: "Source: Worldbank 'Italy Textiles and Clothing Exports, imports, tariffs, by country and region 2020'"
    }), "\n", _jsx(_components.h2, {
      children: "Fashions hottest brands are Italian"
    }), "\n", _jsx(_components.p, {
      children: "Luxury fashion house Gucci has retained its spot as the world's hottest brand as Italian labels continue to reign supreme, according to a previous Lyst Index (October 2022)."
    }), "\n", _jsx(_components.p, {
      children: "Gucci came out on top in a quarter that saw the Kering-owned label grab headlines when it sent 68 sets of identical twins down the runway at Milan Fashion Week."
    }), "\n", _jsx(_components.p, {
      children: "Italian label Prada jumped up one spot to second place amid reports it was seeking a valuation of 1 billion dollars in a new listing on the Milan stock exchange. Searches for the brand increased 44 percent in the quarter."
    }), "\n", _jsx(_components.p, {
      children: "Also moving up one spot was Italian fashion house Valentino, which unveiled its Pink PP campaign."
    }), "\n", _jsx(_components.p, {
      children: "Source: Lyst, October 2022."
    }), "\n", _jsx(_components.p, {
      children: "Miu Miu was named brand of the year 2022 (Lyst, 30 November 2022)."
    }), "\n", _jsx(_components.h2, {
      children: "E-commerce"
    }), "\n", _jsx(_components.p, {
      children: "Italy's internet user population stands at approximately 80%, which places it on the lower end compared to other European countries. Among internet-using Italians, 59% engage in online shopping, with over 50% making online purchases at least once in three months, as per the Europe e-commerce Report 2022."
    }), "\n", _jsx(_components.p, {
      children: "Multichannel retailers are preferred by most online shoppers in Italy, particularly for fashion and beauty products."
    }), "\n", _jsx(_components.p, {
      children: "Fashion dominates the e-commerce revenue share, accounting for more than one fifth of online sales in 2021."
    }), "\n", _jsx(_components.p, {
      children: "Source: E-commercenews.eu, E-commerce in Italy."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Last update: November 2022."
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
